import React from 'react';

export const EditIcon = () => (
  <svg
    width="59"
    height="56"
    viewBox="0 0 59 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_155_957)">
      <path d="M27.9999 30H30.9999V53H27.9999V30Z" fill="white" />
      <circle cx="29.4999" cy="18.5" r="6.5" stroke="white" strokeWidth="4" />
      <path
        d="M27.9999 3L30.9999 3L30.9999 7L27.9999 7L27.9999 3Z"
        fill="white"
      />
      <path d="M13 26L10 26L10 3L13 3L13 26Z" fill="white" />
      <circle
        cx="11.5"
        cy="37.5"
        r="6.5"
        transform="rotate(180 11.5 37.5)"
        stroke="white"
        strokeWidth="4"
      />
      <path d="M13 53L10 53L10 49L13 49L13 53Z" fill="white" />
      <path d="M49 26L46 26L46 3L49 3L49 26Z" fill="white" />
      <circle
        cx="47.5"
        cy="37.5"
        r="6.5"
        transform="rotate(180 47.5 37.5)"
        stroke="white"
        strokeWidth="4"
      />
      <path d="M49 53L46 53L46 49L49 49L49 53Z" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_155_957"
        x="0"
        y="0"
        width="59"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_155_957"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_155_957"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const FullscreenIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 3.81625e-07C0.895431 3.81625e-07 3.81625e-07 0.895431 3.81625e-07 2V20C3.81625e-07 21.1046 0.895431 22 2 22C3.10457 22 4 21.1046 4 20V4H20C21.1046 4 22 3.10457 22 2C22 0.895431 21.1046 3.81625e-07 20 3.81625e-07H2ZM23.4142 20.5858L3.41421 0.585787L0.585787 3.41421L20.5858 23.4142L23.4142 20.5858Z"
      fill="white"
    />
    <path
      d="M2 3.81625e-07C0.895431 3.81625e-07 3.81625e-07 0.895431 3.81625e-07 2V20C3.81625e-07 21.1046 0.895431 22 2 22C3.10457 22 4 21.1046 4 20V4H20C21.1046 4 22 3.10457 22 2C22 0.895431 21.1046 3.81625e-07 20 3.81625e-07H2ZM23.4142 20.5858L3.41421 0.585787L0.585787 3.41421L20.5858 23.4142L23.4142 20.5858Z"
      fill="white"
    />
    <path
      d="M2 3.81625e-07C0.895431 3.81625e-07 3.81625e-07 0.895431 3.81625e-07 2V20C3.81625e-07 21.1046 0.895431 22 2 22C3.10457 22 4 21.1046 4 20V4H20C21.1046 4 22 3.10457 22 2C22 0.895431 21.1046 3.81625e-07 20 3.81625e-07H2ZM23.4142 20.5858L3.41421 0.585787L0.585787 3.41421L20.5858 23.4142L23.4142 20.5858Z"
      fill="white"
    />
    <path
      d="M2 3.81625e-07C0.895431 3.81625e-07 3.81625e-07 0.895431 3.81625e-07 2V20C3.81625e-07 21.1046 0.895431 22 2 22C3.10457 22 4 21.1046 4 20V4H20C21.1046 4 22 3.10457 22 2C22 0.895431 21.1046 3.81625e-07 20 3.81625e-07H2ZM23.4142 20.5858L3.41421 0.585787L0.585787 3.41421L20.5858 23.4142L23.4142 20.5858Z"
      fill="white"
    />
    <path
      d="M48 50C49.1046 50 50 49.1046 50 48L50 30C50 28.8954 49.1046 28 48 28C46.8954 28 46 28.8954 46 30L46 46L30 46C28.8954 46 28 46.8954 28 48C28 49.1046 28.8954 50 30 50L48 50ZM26.5858 29.4142L46.5858 49.4142L49.4142 46.5858L29.4142 26.5858L26.5858 29.4142Z"
      fill="white"
    />
    <path
      d="M48 50C49.1046 50 50 49.1046 50 48L50 30C50 28.8954 49.1046 28 48 28C46.8954 28 46 28.8954 46 30L46 46L30 46C28.8954 46 28 46.8954 28 48C28 49.1046 28.8954 50 30 50L48 50ZM26.5858 29.4142L46.5858 49.4142L49.4142 46.5858L29.4142 26.5858L26.5858 29.4142Z"
      fill="white"
    />
    <path
      d="M48 50C49.1046 50 50 49.1046 50 48L50 30C50 28.8954 49.1046 28 48 28C46.8954 28 46 28.8954 46 30L46 46L30 46C28.8954 46 28 46.8954 28 48C28 49.1046 28.8954 50 30 50L48 50ZM26.5858 29.4142L46.5858 49.4142L49.4142 46.5858L29.4142 26.5858L26.5858 29.4142Z"
      fill="white"
    />
    <path
      d="M48 50C49.1046 50 50 49.1046 50 48L50 30C50 28.8954 49.1046 28 48 28C46.8954 28 46 28.8954 46 30L46 46L30 46C28.8954 46 28 46.8954 28 48C28 49.1046 28.8954 50 30 50L48 50ZM26.5858 29.4142L46.5858 49.4142L49.4142 46.5858L29.4142 26.5858L26.5858 29.4142Z"
      fill="white"
    />
  </svg>
);

export const SidebarIcon = () => (
  <svg
    width="78"
    height="61"
    viewBox="0 0 78 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="2.5"
      width="73"
      height="56"
      rx="7.5"
      stroke="white"
      strokeWidth="5"
    />
    <line x1="27.5" y1="2" x2="27.5" y2="58" stroke="white" strokeWidth="5" />
    <path d="M10 16.5H20" stroke="white" strokeWidth="5" />
    <path d="M10 16.5H20" stroke="white" strokeWidth="5" />
    <path d="M10 16.5H20" stroke="white" strokeWidth="5" />
    <path d="M10 16.5H20" stroke="white" strokeWidth="5" />
    <path d="M10 16.5H20" stroke="white" strokeWidth="5" />
    <path d="M10 25H20" stroke="white" strokeWidth="5" />
    <path d="M10 25H20" stroke="white" strokeWidth="5" />
    <path d="M10 25H20" stroke="white" strokeWidth="5" />
    <path d="M10 25H20" stroke="white" strokeWidth="5" />
    <path d="M10 25H20" stroke="white" strokeWidth="5" />
    <path d="M10 34H20" stroke="white" strokeWidth="5" />
    <path d="M10 34H20" stroke="white" strokeWidth="5" />
    <path d="M10 34H20" stroke="white" strokeWidth="5" />
    <path d="M10 34H20" stroke="white" strokeWidth="5" />
    <path d="M10 34H20" stroke="white" strokeWidth="5" />
  </svg>
);
